module.exports = __webpack_public_path__ + "static/img/silder65.5e33d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/silder65.png
// module id = ludX
// module chunks = 1